import React, { useCallback, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { get } from '../../services/back.service';
import DateSelectorComponent from '../../components/widgets/filterReports';
import Base from '../base';
import ServicesByMonth from '../../components/reports/ServicesByMonth';
import ServicesByTypeClient from '../../components/reports/ServicesByTypeClient';
import DataTableService from '../../components/reports/ServicesByTypeService';
import PaymentsByMonth from '../../components/reports/PaymentsByMonth';
import InsurableSummary from '../../components/reports/InsurableSummary';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const InfoReportCharts = () => {
  const [servicesByMonth, setServicesByMonth] = useState([]);
  const [paymentsByMonth, setPaymentsByMonth] = useState([]);
  const [servicesByClientType, setServicesByClientType] = useState([]);
  const [servicesByServiceType, setServicesByServiceType] = useState([]);
  const [insurableSummary, setInsurableSummary] = useState([]);

  const fetchData = async (filters) => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.years.length) {
        filters.years.forEach(year => queryParams.append('years', year));
      }
      if (filters.months.length) {
        filters.months.forEach(month => queryParams.append('months', month));
      }
      if (filters.dateIni) {
        queryParams.append('date_ini', filters.dateIni);
      }
      if (filters.dateEnd) {
        queryParams.append('date_end', filters.dateEnd);
      }
      if (filters.office !== "") {
        queryParams.append('office', filters.office);
      }

      const response = await get(`/bireportapi/inspection`, {}, queryParams);
      const response_payment = await get(`/bireportapi/payments`, {}, queryParams);
      console.log('Response for services:', response);
      if (response.success && response_payment.success) {
        setServicesByMonth(response.data.monthly_summary)
        setServicesByClientType(response.data.type_client_summary)
        setServicesByServiceType(response.data.services_summary)
        setPaymentsByMonth(response_payment.data.monthly_payments)
        setInsurableSummary(response.data.insurable_summary)
      } else {
        console.log(response)
      }


    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  };

  const processFilter = useCallback((filter) => {
    fetchData(filter);
  }, []);

  return (
    <Base>
      <DateSelectorComponent processFilter={processFilter} />
      <ServicesByMonth data={servicesByMonth} />
      <ServicesByTypeClient data={servicesByClientType} />
      <DataTableService data={servicesByServiceType} />
      <PaymentsByMonth data={paymentsByMonth} />
      <InsurableSummary data={insurableSummary} />
    </Base>
  );
};

export default InfoReportCharts;
